// src/pages/Unauthorized.js
import { Button } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import React from 'react';

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div className="unauthorized-page p-5">
      <h1>403 - Unauthorized Access</h1>
      <p>You don't have permission to access this page. Log out and login again</p>
      <Link to="/auth/logout" className="dropdown-item">
        <Button color="primary" >
          Log out
        </Button>
      </Link>
    </div>
  );
};

export default Unauthorized;